<script setup lang="ts">
import { Link, router, usePage } from "@inertiajs/vue3"
import { LogOut, Settings, SwatchBook } from "lucide-vue-next"
import { computed } from "vue"

import UserInfo from "@/components/UserInfo.vue"
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import {
  managerDashboardPath,
  rootPath,
  sessionPath,
  settingsProfilePath,
} from "@/routes"
import type { Auth } from "@/types"

interface Props {
  auth: Auth
}

const page = usePage()

const isManagerMode = computed(() => {
  return (page.props.auth as Auth).ui_mode === "manager"
})

const handleLogout = () => {
  router.flushAll()
}

defineProps<Props>()
</script>

<template>
  <DropdownMenuLabel class="p-0 font-normal">
    <div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
      <UserInfo :user="auth.user" :show-email="true" />
    </div>
  </DropdownMenuLabel>
  <DropdownMenuSeparator />
  <DropdownMenuGroup>
    <DropdownMenuItem :as-child="true">
      <Link class="block w-full" :href="settingsProfilePath()" as="button">
        <Settings class="mr-2 h-4 w-4" />
        Settings
      </Link>
    </DropdownMenuItem>
    <template v-if="auth.user.role === 'manager'">
      <DropdownMenuItem v-if="isManagerMode" :as-child="true">
        <Link class="block w-full" :href="rootPath()" as="button">
          <SwatchBook class="mr-2 h-4 w-4" />
          Cambiar a Empleado
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem v-else :as-child="true">
        <Link class="block w-full" :href="managerDashboardPath()" as="button">
          <SwatchBook class="mr-2 h-4 w-4" />
          Cambiar a People Manager
        </Link>
      </DropdownMenuItem>
    </template>
  </DropdownMenuGroup>
  <DropdownMenuSeparator />
  <DropdownMenuItem :as-child="true">
    <Link
      class="block w-full"
      method="delete"
      :href="sessionPath({ id: auth.session.id })"
      @click="handleLogout"
      as="button"
    >
      <LogOut class="mr-2 h-4 w-4" />
      Log out
    </Link>
  </DropdownMenuItem>
</template>
